module.exports = __webpack_public_path__ + "img/logo_tzw.488c0a30.png";